import { render, staticRenderFns } from "./StatusImg.vue?vue&type=template&id=2ef30aea&scoped=true&lang=pug&"
import script from "./StatusImg.vue?vue&type=script&lang=ts&"
export * from "./StatusImg.vue?vue&type=script&lang=ts&"
import style0 from "./StatusImg.vue?vue&type=style&index=0&id=2ef30aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef30aea",
  null
  
)

export default component.exports